import { mapState } from "vuex";

export default {
  data() {},
  computed: {
    ...mapState({
      isMatricAssessment: state =>
        state.globalStore.activeFilterParams.isMatricAssessment,
      country: state => state.globalStore.activeFilterParams.country
    })
  },
  methods: {
    contextualGrade(gradeVal) {
      let num;
      if (this.country === "botswana") {
        if (gradeVal < 8) {
          num = gradeVal;
        } else if (gradeVal >= 8 && gradeVal <= 12) {
          num = gradeVal - 7;
        }
      } else {
        num = gradeVal;
      }
      return num;
    },
    contextualGradeLabel() {
      if (this.country === "botswana") {
        return "Std/Form";
      } else if (this.isMatricAssessment) {
        return "Level";
      } else {
        return "Grade";
      }
    },
    contextualSpecificGradeLabel(gradeValue) {
      if (this.country === "botswana") {
        if (gradeValue < 8) {
          return "Standard";
        } else if (gradeValue >= 8 && gradeValue <= 12) {
          return "Form";
        }
      } else if (this.isMatricAssessment) {
        return "Level";
      } else {
        return "Grade";
      }
    },
    contextualSpecificGradeAndLabel(gradeValue) {
      let gradeIdentifier;

      if (this.country === "botswana") {
        if (gradeValue < 8) {
          gradeIdentifier = `Standard ${gradeValue}`;
        } else if (gradeValue >= 8 && gradeValue <= 12) {
          gradeIdentifier = `Form ${gradeValue - 7}`;
        }
      } else if (this.isMatricAssessment) {
        return `Level ${gradeValue}`;
      } else {
        gradeIdentifier = `Grade ${gradeValue}`;
      }
      return gradeIdentifier;
    },
    contextualSpecificGradeAndLabelMin(gradeValue) {
      let gradeIdentifier;

      if (this.country === "botswana") {
        if (gradeValue < 8) {
          gradeIdentifier = `Std ${gradeValue}`;
        } else if (gradeValue >= 8 && gradeValue <= 12) {
          gradeIdentifier = `Form ${gradeValue - 7}`;
        }
      } else if (this.isMatricAssessment) {
        return `Level ${gradeValue}`;
      } else {
        gradeIdentifier = `Gr ${gradeValue}`;
      }
      return gradeIdentifier;
    },
    contextualSpecificGradeAndPrefix(gradeValue) {
      let gradeIdentifier;
      if (gradeValue == 13) {
        gradeIdentifier = "Adult";
        return gradeIdentifier;
      }
      if (this.country === "botswana") {
        if (gradeValue < 8) {
          gradeIdentifier = `S${gradeValue}`;
        } else if (gradeValue >= 8 && gradeValue <= 12) {
          gradeIdentifier = `F${gradeValue - 7}`;
        }
      } else {
        gradeIdentifier = `${gradeValue}`;
      }
      return gradeIdentifier;
    },
    linearizeGradeToPercentage(gradeValue) {
      const MAX_PERCENTAGE = 100;
      const MAX_GRADE = 9;
      return Math.floor((MAX_PERCENTAGE / MAX_GRADE) * gradeValue);
    }
  }
};
